import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Notification } from '../../../../../common/notification'
import { getStatusQuickAssessment } from '../../helper'
import classes from '../../index.module.scss'

export const Table = ({ itemsLeft, itemsRight }) => {
  const renderHeader = (isLeft) => {
    return (
      <div className="w50">
        <Element
          style={{
            borderBottom: '1px solid #D5D5D5',
            color: '#191D25',
            borderRight: isLeft ? '1px solid #D5D5D5' : undefined,
          }}
          className={classes.header}
        >
          <div className={classes.indicator}>
            <Translate value="financialAnalysis.INDICATOR" />
          </div>
          <div className={classes.description}>
            <Translate value="financialAnalysis.DESCRIPTION" />
          </div>
          <div className={classes.status}>
            <Translate value="financialAnalysis.STATUS" />
          </div>
        </Element>
      </div>
    )
  }

  const renderItem = (item, isLeft, isLastItem) => {
    if (!item) {
      return
    }

    return (
      <div
        style={{
          borderRight: isLeft ? '1px solid #D5D5D5' : undefined,
          paddingBottom: isLastItem ? 12 : undefined,
        }}
        className={`w50 dFlex alignItemsCenter ${classes.pdy6}`}
      >
        <div className={classes.indicator}>{item.indicatorName}</div>
        <div className={classes.description}>{item.description}</div>
        <div className={classes.status}>
          {getStatusQuickAssessment(item.status)}
        </div>
      </div>
    )
  }

  return (
    <div className={classes.table}>
      <div className="dFlex">
        {renderHeader(true)}
        {renderHeader(false)}
      </div>
      {!itemsLeft.length ? (
        <div className="pt3">
          <Notification isI18n value="common.NO_DATA" />
        </div>
      ) : (
        itemsLeft.map((_, index) => {
          const isLastItem = index === itemsLeft.length - 1

          return (
            <div key={index} className="dFlex">
              {renderItem(itemsLeft[index], true, isLastItem)}
              {renderItem(itemsRight[index], false, isLastItem)}
            </div>
          )
        })
      )}
    </div>
  )
}

Table.propTypes = {
  itemsLeft: PropTypes.array.isRequired,
  itemsRight: PropTypes.array.isRequired,
}
